import React, { useEffect, useState } from 'react';
import '@gouvfr/dsfr/dist/component/tab/tab.min.css';
import { OngletsDefaultProps } from "./Onglet.types";
var Onglet = function (_a) {
    var id = _a.id, children = _a.children, nomSystemeOnglet = _a.nomSystemeOnglet, ongletActif = _a.ongletActif, onChangeOnglet = _a.onChangeOnglet;
    var _b = useState(0), activeTab = _b[0], setActiveTab = _b[1];
    var tabsPanel = [];
    if (Array.isArray(children)) {
        tabsPanel = children;
    }
    else {
        tabsPanel = [children];
    }
    var changeOnglet = function (ongletNumber) {
        if (onChangeOnglet instanceof Function) {
            onChangeOnglet(ongletNumber);
        }
        setActiveTab(ongletNumber);
    };
    var changeOngletClavier = function (_a) {
        var key = _a.key;
        if (["Home", "End", "ArrowLeft", "ArrowRight"].includes(key)) {
            var indexOnglet = 0;
            if (key === "End") {
                indexOnglet = tabsPanel.length - 1;
            }
            if (key === "ArrowLeft") {
                indexOnglet = activeTab - 1;
                if (indexOnglet < 0) {
                    indexOnglet = tabsPanel.length - 1;
                }
            }
            if (key === "ArrowRight") {
                indexOnglet = (activeTab + 1) % tabsPanel.length;
            }
            changeOnglet(indexOnglet);
        }
    };
    useEffect(function () {
        if (!!ongletActif && activeTab !== ongletActif) {
            changeOnglet(ongletActif);
        }
    }, [ongletActif]);
    return (React.createElement("div", { className: "fr-tabs" },
        React.createElement("ul", { className: "fr-tabs__list", role: "tablist", "aria-label": nomSystemeOnglet }, tabsPanel.map(function (tabPanel, key) {
            return (React.createElement("li", { role: "presentation", key: id + key + tabPanel.props.titre, onClick: function () {
                    changeOnglet(key);
                }, onKeyDownCapture: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    changeOngletClavier(e);
                } },
                React.createElement("button", { id: "tabpanel-".concat(id, "-").concat(key), className: "fr-tabs__tab", tabIndex: activeTab === key ? 0 : -1, role: "tab", "aria-selected": activeTab === key, type: "button", "aria-controls": "tabpanelcontent-".concat(id, "-").concat(key) }, tabPanel.props.titre)));
        })),
        tabsPanel.map(function (child, index) {
            if (index !== activeTab) {
                return null;
            }
            return (React.createElement("div", { className: "fr-tabs__panel fr-tabs__panel--selected", key: "tabpanelcontent-".concat(id, "-").concat(index), id: "tabpanelcontent-".concat(id, "-").concat(index), role: "tabpanel", "aria-labelledby": id, tabIndex: 0 }, child.props.children));
        })));
};
Onglet.defaultProps = OngletsDefaultProps;
export default Onglet;
